import { InventoryCategoryValues } from '@/components/forms/form-inventory-category/FormInventoryCategory';
import useDeleteEquipmentType from '@/hooks/queries/equipments-api/useDeleteEquipmentType';
import useGetEquipmentTypeById from '@/hooks/queries/equipments-api/useGetEquipmentTypeById';
import usePatchEquipmentTypes from '@/hooks/queries/equipments-api/usePatchEquipmentTypes';
import useGetOrganizationSports from '@/hooks/queries/sports-api/useGetOrganizationSports';
import { getChangedValues } from '@/utils/forms';
import { useParams } from 'react-router-dom';

const useEditInventoryCategory = () => {
  const { id } = useParams();
  const {
    data: invetoryType,
    isLoading: isLodingEquipment,
    isError: isErrorEquipment
  } = useGetEquipmentTypeById(id);
  const {
    data: sports,
    isLoading: isLoadingSports,
    isError: isErrorSports
  } = useGetOrganizationSports();
  const { mutate, isPending } = usePatchEquipmentTypes();
  const { mutate: deleteEquipmentType, isPending: isPendingDelete } =
    useDeleteEquipmentType();

  const isError = isErrorEquipment || isErrorSports;
  const isLoading = isLodingEquipment || isLoadingSports;

  const defaultValues = {
    name: invetoryType?.name ?? '',
    description: invetoryType?.description ?? '',
    sports: invetoryType?.sports?.map((sport) => {
      return { label: sport.name, value: sport.id };
    })
  };

  const onSubmit = (data: InventoryCategoryValues) => {
    const onlyChangedData = getChangedValues<Partial<InventoryCategoryValues>>(
      defaultValues,
      data
    );
    mutate({
      payload: {
        ...onlyChangedData,
        sports: onlyChangedData.sports?.map((sport) => sport.value)
      },
      equipmentTypeId: invetoryType?.id ?? ''
    });
  };

  return {
    isError,
    isLoading,
    isPending,
    sports,
    invetoryType,
    deleteEquipmentType,
    isPendingDelete,
    onSubmit,
    defaultValues
  };
};

export default useEditInventoryCategory;
